// extracted by mini-css-extract-plugin
export default {"parent":"table_parent__kIK76","parentRowManager":"table_parentRowManager__rqpvn","tableCellPhone":"table_tableCellPhone__erjV+"};